var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_879_458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57266 7.36891L11.3521 5.56503L3.01863 0.694551L9.57266 7.36891ZM1.32822 0.303711C0.942688 0.514164 0.675781 0.905004 0.675781 1.38604L0.675781 14.6446C0.675781 15.1256 0.942688 15.5164 1.32822 15.6968L8.92023 8.00026L1.32822 0.303711ZM13.9322 7.09832L12.1824 6.07612L10.2251 8.00026L12.1824 9.95446L13.9618 8.93227C14.4956 8.51136 14.4956 7.51923 13.9322 7.09832ZM3.01863 15.306L11.3521 10.4656L9.57266 8.66168L3.01863 15.306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.95,
    height: 15.7,
    fill: "white",
    transform: "translate(0.675781 0.150391)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.18632a65d95198f72c0905c12e05ae8c.svg";
export { ForwardRef as ReactComponent };